import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=38b361e9"
import script from "./Gateway.vue?vue&type=script&lang=ts"
export * from "./Gateway.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports